import { Card, Placeholder } from 'react-bootstrap';
import Paper from '../../components/Paper';

const PlaceholderPublicForm = () => {
  return (
    <>
      <Paper>
        <Placeholder as={Card.Title} animation="glow">
          <Placeholder className="mb-3" xs={12} />
        </Placeholder>
        <Placeholder as={Card.Text} animation="glow">
          <Placeholder xs={7} /> <Placeholder xs={4} /> <Placeholder xs={4} />{' '}
          <Placeholder xs={6} /> <Placeholder xs={8} />
        </Placeholder>
      </Paper>
      <Paper>
        <Placeholder as={Card.Title} animation="glow">
          <Placeholder className="mb-3" xs={10} />
        </Placeholder>
        <Placeholder as={Card.Text} animation="glow">
          <Placeholder xs={6} />
        </Placeholder>
      </Paper>
    </>
  );
};

export default PlaceholderPublicForm;
